import { useContext } from 'react'
import { usePortalTranslate } from '@/hooks'
import ReturnCard from './return-components/return-card'
import { TopBar } from '../refund-methods/refund-components/top-bar'
import { EditedCopiesContext } from '@/ui/components/portal-preview/preview-contexts'
import { ReverCard } from '../refund-methods/refund-components/rever-card'
import { useAppSelector } from '@/redux/hooks'
import { Button } from '@/ui/components/portal-preview/pages/pages-components/button'

function ReturnMethodsPage() {
  const editedCopies = useContext(EditedCopiesContext)
  const { translate } = usePortalTranslate(editedCopies)
  const settingsReturnMethods = useAppSelector(
    (store) => store.settingsApi.settings.response.return_logistics
  )
  const returnMethods = [
    ...new Set(settingsReturnMethods?.map((rm) => rm.return_method))
  ]

  return (
    <>
      <TopBar page="return-method" title={translate('return_page_title')} />
      <div className="flex grow flex-col content-center items-center">
        <ReverCard>
          {returnMethods
            ? returnMethods.map((method, index) => {
                return <ReturnCard key={index} method={method} />
              })
            : null}

          <div className="mt-6 flex w-full items-center justify-center">
            <div className="w-full sm:w-fit">
              <Button id="returnMethodContinue">
                {translate('return_page_button_continue')}
              </Button>
            </div>
          </div>
        </ReverCard>
      </div>
    </>
  )
}

export default ReturnMethodsPage
